import React from "react";
import { SyncVisualHook } from "./SyncVisualHook";

const steps = [
  { step: "1", label: "Choose source board" },
  { step: "2", label: "Set share rules" },
  { step: "3", label: "Items appear automatically" },
];

const SyncVisual = () => {
  return (
    <div className="w-full max-w-[700px] bg-white border border-solid border-[#d0d4e4] rounded-2xl p-6 mb-8 shadow-sm">
      <div className="flex justify-between items-center px-1 mb-4">
        {steps.map(({ step, label }) => (
          <div key={step} className="flex items-center gap-1.5">
            <div className="w-5 h-5 rounded-full bg-[#0073ea] text-white flex items-center justify-center text-[10px] font-bold flex-shrink-0">
              {step}
            </div>
            <span className="text-[11px] text-[#676879]">{label}</span>
          </div>
        ))}
      </div>

      <SyncVisualHook />

      <p className="text-center text-[11px] text-[#676879]">
        Changes on any connected board reflect instantly on every connected board
      </p>
    </div>
  );
};

export default SyncVisual;
